import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDischargeField } from "../../../../Redux/actions/dischargeActions";

export default function ClinicalSummary() {
  const dispatch = useDispatch();
  const clinicalSummary = useSelector(
    (state) => state.discharge?.clinicalSummary || ""
  );

  const handleChange = (e) => {
    dispatch(setDischargeField("clinicalSummary", e.target.value));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-3 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        1. Clinical Summary
      </h3>
      <div className="border border-gray-200 rounded-md overflow-hidden bg-white focus-within:border-teal-500 focus-within:ring-1 focus-within:ring-teal-500 transition">
        <textarea
          value={clinicalSummary}
          onChange={handleChange}
          className="w-full h-[120px] p-3 text-sm outline-none resize-none"
          placeholder="Enter clinical summary, hospital course, examination findings..."
        ></textarea>
      </div>
    </div>
  );
}
